import React, { useEffect } from 'react';
import PleaseWait from '../../../components/PleaseWait';

export const Reset = () => {
  useEffect(() => {
    window.sessionStorage.removeItem('wmi');

    window.localStorage.removeItem('wm-d');
    window.localStorage.removeItem('wm-df');
    window.location = '/wm'
  }, []);

  return (
    <PleaseWait />
  )
};
